import { pipeArguments } from '../../Pipeable/dist/effect-Pipeable.esm.js';
import { StreamTypeId, toChannel } from '../../Stream/dist/effect-Stream.esm.js';

/**
 * @since 2.0.0
 */
const streamVariance = {
  _R: _ => _,
  _E: _ => _,
  _A: _ => _
};

/**
 * @since 2.0.0
 * @category constructors
 */
class Class {
  /**
   * @since 2.0.0
   */
  [StreamTypeId] = streamVariance;

  /**
   * @since 2.0.0
   */
  pipe() {
    return pipeArguments(this, arguments);
  }

  /**
   * @since 2.0.0
   */

  /**
   * @internal
   */
  get channel() {
    return toChannel(this.toStream());
  }
}

export { Class };
